import { Container } from "react-bootstrap";
import pic from "../assets/homepageImg.jpg";
import { Alert, Box, Button, Grid, Typography } from "@mui/joy";
import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Paper, Step, StepContent, StepLabel, Stepper } from "@mui/material";
import ArrowCircleDownSharpIcon from '@mui/icons-material/ArrowCircleDownSharp';
import ArrowCircleUpSharpIcon from '@mui/icons-material/ArrowCircleUpSharp';
import ReplayCircleFilledSharpIcon from '@mui/icons-material/ReplayCircleFilledSharp';
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function Homepage() {
  const navigate = useNavigate();

  const [showTab2, setTab2Show] = useState(false);
  const handleCloseTab2 = () => setTab2Show(false);
  const handleShowTab2 = () => setTab2Show(true);

  const [showTab3, setTab3Show] = useState(false);
  const handleCloseTab3 = () => setTab3Show(false);
  const handleShowTab3 = () => setTab3Show(true);

  const isNoticeVisible = false;
  const isSuccessNoticeVisible = false;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [activeStep, setActiveStep] = React.useState(0);

  // const currentURL = window.location.href;
  // if (
  //   process.env.REACT_APP_ENV === "production" &&
  //   currentURL.includes("herokuapp.com")
  // ) {
  //   alert("Please use new URL : " + BASE_URL_FRONTEND);

  // }

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const diagonalContainerStyle = {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    height: isMobile ? 'auto' : '680px',
    width: '100%',
    position: 'relative',
    background: 'white',
    marginTop: '2rem',
  };

  const diagonalTextStyle = {
    flex: '0 0 40%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    zIndex: 2,
  };

  const diagonalImageStyle = {
    flex: '0 0 60%',
    height: isMobile ? '200px' : '100%',
    width: isMobile ? '100%' : '200px',
    objectFit: 'cover',
    clipPath: isMobile ? 'none' : 'polygon(25% 0, 100% 0, 100% 100%, 0 100%)'
  };

  const diagonalLeftSideStyle = {
    flex: '0 0 40%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '2rem',
    background: "#006699",
    flexDirection: "column",
    position: "relative",
    zIndex: 2,
    color: "white",
    clipPath: isMobile
      ? "none"
      : "polygon(0 0, 100% 0, 70% 100%, 0 100%)"
  };

  const diagonalRightSideStyle = {
    flex: '0 0 60%',
    height: isMobile ? '200px' : '100%',
    width: '100%',
    objectFit: 'cover',
    background: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column",
    gap: "2rem",
    padding: '2rem',
  };


  const steps = [
    {
      label: 'Create a free account through a few simple steps',
      description: `Sign up and confirm your account creation to get started`,
    },
    {
      label: 'Share your completed training records with your current or future employer',
      description:
        'Provide your information to your employer and they will assign your list of courses.',
    },
    {
      label: 'Access the standardized training modules required by the home',
      description: `At your own pace, register and complete the bite sized training module required by your job.`,
    },
    {
      label: 'Take your digital passport wherever you go',
      description: `Your training record is your passport to demonstrate that you have completed the orientation and annual mandatory training required in Long Term Care`,
    }
  ];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };


  return (
    <Container fluid style={{ padding: "0" }}>
      <Box
        sx={{
          marginTop: "3pc",
          position: "relative",
          width: "100%",
          height: { xs: "500px", md: "100%" },
        }}
      >
        <Modal
          style={{ width: "50%", left: "30%", top: "10%" }}
          show={showTab2}
          onHide={handleCloseTab2}
          id="homepageTab2"
        >
          <Modal.Header closeButton>
            <Modal.Title>I’m New Here – Help Me Create My Account</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Your Care Passport portal account contains an official record of the
              long- term care home onboarding and annual mandatory training you
              have completed.<br></br><br></br> Your training records stay with you and can be
              shared with any LTC home or employer that uses the portal — no need
              to repeat training when you switch workplaces. You will also receive
              email reminders for any training that is due to expire and needs to
              be renewed.
              <br></br>
              <br></br>
              <a
                href="https://carepassportcareltc.atlassian.net/wiki/external/MWZkYTUyNzY1NDY1NDM5Zjk3Mzg2ODI2NzYxNDlkMDY"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#006699", textDecoration: "underline", fontWeight: 600 }}
              >
                See More Information
              </a> for additional details on the overall process.<br></br>
              <br></br>
              Click the <Link style={{ color: "#006699", textDecoration: "underline", fontWeight: 600 }} to="userRegistration">Create Account</Link> button to get started.
            </p>
          </Modal.Body>
        </Modal>
        <Modal
          style={{ width: "50%", left: "30%", top: "10%" }}
          show={showTab3}
          onHide={handleCloseTab3}
          id="homepageTab3"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              We're a New Organization - What Do We Need to Know?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              The Care Passport portal simplifies training management by bringing
              registration, tracking, and reporting together in one place. You
              define the training required for each role in your organization and
              choose the approved training partners that meet your needs. When you
              hire someone who already has a Care Passport, their verified records
              come with them – eliminating wasteful retraining. The portal tracks
              completions and generates detailed reports at the individual, home,
              or organizational level.<br></br><br></br> To get started, contact us. We’ll create
              your organizational account and help you configure it to match your
              staffing roles and training requirements.<br></br><br></br> For more information on
              the Council for Advancement of Resident-care Education in LTC and
              how the Care Passport system works with your home, see <a href="https://www.care-ltc.ca" target="_blank" rel="noopener noreferrer" style={{ color: "#006699", textDecoration: "underline", fontWeight: 600 }}>CARE-LTC</a>.

            </p>
          </Modal.Body>
        </Modal>

        <div style={diagonalContainerStyle}>
          <div style={diagonalTextStyle}>
            <div>
              <div>
                <Box>
                  {isNoticeVisible && (
                    <Alert
                      key="notice-board-error"
                      variant="soft"
                      color="danger"
                      startDecorator={<InfoOutlinedIcon />}
                      // endDecorator={
                      //   <IconButton
                      //     variant="soft"
                      //     size="sm"
                      //     color="danger"
                      //     onClick={() => setIsNoticeVisible(false)}
                      //   >
                      //     <CloseRoundedIcon />
                      //   </IconButton>
                      // }
                      sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        marginBottom: 2,
                        width: '100%'
                      }}
                    >
                      <Typography level="body-sm" color="info">
                        {/* ** Service Disruption Notice - Aug 29, 2026 - Care Passport will be unavailable due to planned maintenance.  During the upgrade, all features of Care Passport and the Lambton College LTC Training Platform will be unavailable.  Thank you for your patience. */}
                URGENT SERVICE DISRUPTION: In response to the global PHP security vulnerability, the Lambton College training platform has been pro-actively put in maintenance mode while the security patch is implemented.  This is expected to be completed shortly - thank you for your patience.  This vulnerability does not impact access to Care Passport nor the records within but impacts your ability to register for and access courses on the Lambton College platform.
                      </Typography>
                    </Alert>
                  )}
                  {isSuccessNoticeVisible && (
                    <Alert
                      key="notice-board-success"
                      variant="soft"
                      color="success"
                      startDecorator={<InfoOutlinedIcon />}
                      sx={{
                        position: 'sticky',
                        top: 10,
                        zIndex: 10,
                        marginBottom: 2,
                        width: '100%'
                      }}
                    >
                      <Typography level="body-sm" color="info">
                          🚀 Portal Update - Aug. 30, 2026 - Care Passport has been updated to improve the user experience!  The updates include direct access to courses via the user's Care Passport account and updated Help documentation.  Pls see: - <a href="https://carepassportcareltc.atlassian.net/wiki/external/NTgwZmU1MjlhZmIzNGJhZjg0YWZiZjkyZTAxNjI5NmI">Care Passport Update</a>
                        </Typography>
                    </Alert>
                  )}
                  <h1 className="display-3" style={{ "fontFamily": "'Open Sans', sans-serif", "color": "#006699" }}>
                    Simplify your<br></br>Long Term Care<br></br>Training Record
                  </h1>
                </Box>

              </div>
            </div>
          </div>
          <img
            src={pic}
            alt="Background"
            style={diagonalImageStyle}
          />
        </div>
        <div style={{ ...diagonalContainerStyle, marginTop: "0rem", height: isMobile ? 'auto' : '450px' }}>
          <div
            style={{
              ...diagonalLeftSideStyle,

            }}
          >
            <Button
              style={{
                margin: "2%",
                padding: "20px 50px",
                width: "20rem",
                borderRadius: "10pc",
                backgroundColor: "white",
                color: "#006699",
                fontWeight: 700,
                fontSize: "1.2rem",
                marginRight: isMobile ? '0' : '15%',
              }}
              onClick={() => navigate('login')}
            >
              <Typography className="display-6" sx={{ color: "#006699" }}>I Have an Account - Take Me To The Login Page</Typography>
            </Button>

          </div>

          <div
            style={{
              ...diagonalRightSideStyle,

            }}
          >
            <Grid container spacing={2} sx={{ justifyContent: "center", alignContent: "center" }}>
              <Grid xs={12} md={6} sx={{ textAlign: "center" }}>
                <Button
                  style={{
                    margin: "2%",
                    padding: "20px 40px",
                    //fontSize: "1.2rem",
                    maxWidth: "22rem",
                    borderRadius: "10pc",
                    backgroundColor: "#006699"
                  }}
                  onClick={handleShowTab2}
                >
                  <Typography className="display-6" sx={{ color: "white" }}>I’m New Here – Help Me Create My Account</Typography>
                </Button>
              </Grid>
              <Grid xs={12} md={6} sx={{ textAlign: "center" }}>
                <Button
                  style={{
                    margin: "2%",
                    padding: "20px 40px",
                    //fontSize: "1.2rem",
                    maxWidth: "22rem",
                    borderRadius: "10pc",
                    backgroundColor: "#006699"
                  }}
                  onClick={handleShowTab3}
                >
                  <Typography className="display-6" sx={{ color: "white" }}>We're a New Organization - What Do We Need to Know?</Typography>
                </Button>
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={12} md={12} style={{ justifyContent: "space-between", alignContent: "center", color: "#006699", fontFamily: "'Open Sans', sans-serif" }}>
                <h2 className="display-5">Access and track your assigned training through the centralized <br></br>Care Passport system.</h2>
              </Grid>
            </Grid>
          </div>
        </div>
      </Box>
      <Box>
        <Grid container spacing={2} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <Grid xs={12} md={3} style={{ justifyContent: "center", alignContent: "center", textAlign: "center", marginTop: "2rem", color: "#006699", fontFamily: "'Open Sans', sans-serif" }}>
            <h2 className="display-5">How it works?</h2>
          </Grid>
          <Grid xs={12} md={9} style={{ marginTop: "2rem", color: "#006699", fontFamily: "'Open Sans', sans-serif" }}>
            <Box sx={{ width: "100%", padding: "2rem" }}>
              <Stepper sx={{}} activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel
                      sx={{
                        '& .MuiStepLabel-label': {
                          color: '#006699',
                          fontWeight: 700,
                          fontSize: '1.5rem',
                        }
                      }}
                    >
                      <h2 className="display-5" style={{ "fontSize": "2rem" }}>{step.label}</h2>
                    </StepLabel>
                    <StepContent>
                      <Typography>{step.description}</Typography>
                      <Box sx={{ mb: 2 }}>
                        <Button
                          variant="contained"
                          onClick={handleNext}
                          sx={{ mt: 1, mr: 1 }}
                        >
                          {index === steps.length - 1 ? <CheckCircleSharpIcon sx={{ fontSize: "3pc", color: "#006699" }} /> : <ArrowCircleDownSharpIcon sx={{ fontSize: "3pc", color: "#006699" }} />}
                        </Button>
                        <Button
                          disabled={index === 0}
                          variant="contained"
                          onClick={handleBack}
                          sx={{ mt: 1, mr: 1 }}
                        >
                          {index > 0 && <ArrowCircleUpSharpIcon sx={{ fontSize: "3pc", color: "#006699" }} />}
                        </Button>
                      </Box>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
              {activeStep === steps.length && (
                <Paper square elevation={0} sx={{ p: 3 }}>
                  <Typography level="body-lg">That's all - you need!</Typography>
                  <Button variant="contained" onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                    <ReplayCircleFilledSharpIcon sx={{ fontSize: "3pc", color: "#006699" }} />
                  </Button>
                </Paper>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default Homepage;
